// eslint-disable-next-line
import util from 'util';

import React, { Component } from 'react';
import { connect } from 'react-redux';

// eslint-disable-next-line
import * as MuiCore from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import * as coreSelectors from '../core/selectors';
import * as serviceSelectors from './selectors';
import * as serviceActions from './actions';

import * as Formatters from '../ui/Formatters';
import * as MessageFormat from './MessageFormat';
import LinkedText from '../ui/LinkedText';

import * as ServiceIcons from './Icons';
import ArchiveIcon from '@material-ui/icons/Archive';
import UnarchieveIcon from '@material-ui/icons/Unarchive';
import AccountCircle from '@material-ui/icons/AccountCircle';
import SentimentData from './SentimentData';
import InfoIcon from '@material-ui/icons/Info';
import CallRecordingPlayer from 'ui/CallRecordingPlayer';

const styles = theme => ({
  ...MessageFormat.styles(theme),
});


/*
 * Format for an outcall
 */
class InboundCallFormat extends Component {

  state = {
    showReadTooltip: false,
    showArchiveTooltip: false,
    showFollowUpTooltip: false,
    tabValue: "Message"
  }

  formatTime = (duration, round) => {
    if(round){
      duration = Math.round(duration / 30) * 30;
    }
    if(duration < 60){
      // return '00:00:' + duration < 10 ? '0' + duration : duration;
      return `00:00:${duration < 10 ? '0' + String(duration) : String(duration)}`
    } else if(duration < 60*60) {
      let min = parseInt(duration/60);
      let sec = parseInt(duration - (min*60));
      return `00:${min < 10 ? '0' + String(min): String(min)}:${sec < 10 ? '0' + String(sec): String(sec)}`
    } else {
      let hour = parseInt(duration/(60*60));
      let min = parseInt((duration - (hour*60*60))/60);
      let sec = parseInt(duration - (min*60) - (hour*60*60));
      return `${hour < 10 ? '0' + String(hour): String(hour)}:${min < 10 ? '0' + String(min): String(min)}:${sec < 10 ? '0' + String(sec): String(sec)}`
    }
  }

  componentDidMount(){
    setTimeout(() => {
      this.setState({tabValue: 'Message'})
    }, 200);
  }

  render() {
    /* eslint-disable */
    const { classes, message,toggleFollowup, archiveMessage, 
      unarchiveMessage, markMessageRead, unmarkMessageRead,
      setActivityDetailOpen, newContact, user } = this.props;
    const displayCallRecording = user?.userAccountRoles?.filter(role => role.accountId === message.accountId)?.[0]?.displayRecording === 'Y' && message?.callRecordingAudioKey;
    return (
      <div className={classes.formatTop}>
        <div className={classes.messageSender}>
          <LinkedText value={(message.messageType === 'VIP' ? 'VIP call ' : 'Inbound call ') + Formatters.formatPhoneNumber(message.ani) + ' -> ' + Formatters.formatPhoneNumber(message.dnis)} onClick={this.props.openContactLink}/>
        </div>
        <div className={classes.taken}>
          {Formatters.formatDateTime(message.taken)}
        </div>
        {/* <div className={classes.taken}>
          Reference ID: {message.messageId}
        </div>
        <div className={classes.taken}>
          Contact Description: {message.contactDescription}
        </div> */}

<MuiCore.Grid item>
            <MuiCore.Grid container style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', marginTop: 10}}>
            <MuiCore.Grid item style={{textAlign: 'center', margin: 10, cursor: message.dnis && 'pointer'}} onClick={() => {
                if(message.ani){
                  newContact(message.ani)
                }
              }}>
                <MuiCore.Grid item style={{height: 50, width: 50, marginLeft: 10}}>
                  <MuiCore.Grid item style={{verticalAlign: 'middle', height: '100%'}}>
                    <ServiceIcons.SaveContactIcon fontSize='medium' style={{marginTop: 13, color:'#122457'}}/>
                  </MuiCore.Grid>
                </MuiCore.Grid>
                {/* <ServiceIcons.SaveContactIcon fontSize='medium' style={{marginTop: 13, color:'#122457'}}/> */}
                <MuiCore.Typography style={{fontFamily: 'Sofia-bold', fontSize: 11, marginTop: 10}}>
                  Save contact
                </MuiCore.Typography>
              </MuiCore.Grid>
              <MuiCore.Tooltip title={message.userId !== user.userId && "You don't have permission to do this"} open={this.state.showReadTooltip && message.userId !== user.userId} onMouseEnter={() => this.setState({showReadTooltip: true})} onMouseLeave={() => this.setState({showReadTooltip: false})}>
                <span onMouseLeave={()=> {this.setState({showReadTooltip: false})}}>
                  <MuiCore.Grid item style={{textAlign: 'center', margin: 10, cursor: message.userId === user.userId && 'pointer'}} onClick={() => {
                    if(message.read){
                      unmarkMessageRead(message.messageId)
                    }else{
                      markMessageRead(message.messageId)
                    }
                    setActivityDetailOpen(false);
                  }}>
                    <MuiCore.Grid item style={{backgroundColor: 'rgba(0,0,0,0.1)', borderRadius: 40, height: 50, width: 50, marginLeft: 10}}>
                      <MuiCore.Grid item style={{verticalAlign: 'middle', height: '100%'}}>
                        <MuiCore.SvgIcon xmlns="http://www.w3.org/2000/svg" width="31.5" height="21" viewBox="0 0 31.5 21" style={{color: message.userId !== user.userId ? 'grey' : '#122457', marginTop: 13}}>
                          <path d="M.6.99V16.571L11.439,9.345ZM16.294,13.3l-3.726-2.823L.6,18.49V21.2H32.1V18.49L19.907,10.361Zm15.694,3.387V1.1L21.149,9.458ZM16.294,11.265,30.52.2H2.068Z" transform="translate(-0.6 -0.2)"/>
                        </MuiCore.SvgIcon>
                      </MuiCore.Grid>
                    </MuiCore.Grid>
                    <MuiCore.Typography style={{fontFamily: 'Sofia-bold', fontSize: 11, marginTop: 10, color: message.userId !== user.userId && 'grey'}}>
                      {message.read || message.userId !== user.userId ? 'Mark unread' : 'Mark read'}
                    </MuiCore.Typography>
                  </MuiCore.Grid>
                </span>
              </MuiCore.Tooltip>
              <MuiCore.Tooltip title={message.userId !== user.userId && "You don't have permission to do this"} open={this.state.showArchiveTooltip && message.userId !== user.userId} onMouseEnter={() => this.setState({showArchiveTooltip: true})}>
                <span onMouseLeave={()=> {this.setState({showArchiveTooltip: false})}}>
                  <MuiCore.Grid item style={{textAlign: 'center', margin: 10, cursor: message.userId === user.userId && 'pointer'}} onClick={() => {
                    if(message.archived){
                      unarchiveMessage(message.messageId);
                    }else {
                      archiveMessage(message.messageId);
                    }
                    setActivityDetailOpen(false);
                    }}>
                    <MuiCore.Grid item style={{backgroundColor: 'rgba(0,0,0,0.1)', borderRadius: 40, height: 50, width: 50}}>
                      <MuiCore.Grid item style={{verticalAlign: 'middle', height: '100%'}}>
                        {message.archived ? <UnarchieveIcon fontSize='medium' style={{marginTop: 13, color:message.userId !== user.userId ? 'grey' : '#122457'}}/> : <ArchiveIcon fontSize='medium' style={{marginTop: 13, color:message.userId !== user.userId ? 'grey' : '#122457'}}/>}
                      </MuiCore.Grid>
                    </MuiCore.Grid>
                    <MuiCore.Typography style={{fontFamily: 'Sofia-bold', fontSize: 11, marginTop: 10, color: message.userId !== user.userId && 'grey'}}>
                    {message.archived ? 'Unarchive': 'Archive'}
                    </MuiCore.Typography>
                  </MuiCore.Grid>
                </span>
              </MuiCore.Tooltip>
              <MuiCore.Grid item style={{textAlign: 'center', margin: 10, cursor: 'pointer'}} onClick={() => {
                  this.props.openAssist(message);
                }}>
                <MuiCore.Grid item style={{backgroundColor: 'rgba(0,0,0,0.1)', borderRadius: 40, height: 50, width: 50}}>
                  <MuiCore.Grid item >
                    <ServiceIcons.AssistIcon  style={{marginTop: 12}}/>
                  </MuiCore.Grid>
                </MuiCore.Grid>
                <MuiCore.Typography style={{fontFamily: 'Sofia-bold', fontSize: 11, marginTop: 10}}>
                  Assist
                </MuiCore.Typography>
              </MuiCore.Grid>
              <MuiCore.Tooltip title={message.userId !== user.userId && "You don't have permission to do this"} open={this.state.showFollowUpTooltip && message.userId !== user.userId} onMouseEnter={() => this.setState({showFollowUpTooltip: true})}>
                <span onMouseLeave={() => {this.setState({showFollowUpTooltip: false})}}>
                  <MuiCore.Grid item style={{textAlign: 'center', margin: 10, cursor: message.deliveryId && message.userId === user.userId && 'pointer'}} onClick={() => {
                      if(message.deliveryId && message.userId === user.userId){
                        toggleFollowup(message, true)
                      }
                    }}>
                    <MuiCore.Grid item style={{backgroundColor: 'rgba(0,0,0,0.1)', borderRadius: 40, height: 50, width: 50}}>
                      <MuiCore.Grid item style={{verticalAlign: 'middle', height: '100%'}}>
                        <ServiceIcons.FollowupIcon style={{color: message.userId !== user.userId ? 'grey' : '#122457', marginTop: 13}} followup={message.followup}/>
                      </MuiCore.Grid>
                    </MuiCore.Grid>
                    <MuiCore.Typography style={{fontFamily: 'Sofia-bold', fontSize: 11, marginTop: 10, color: message.userId !== user.userId && 'grey'}}>
                      Follow Up
                    </MuiCore.Typography>
                  </MuiCore.Grid>
              </span>
              </MuiCore.Tooltip>
            </MuiCore.Grid>
          </MuiCore.Grid>
        
        <MuiCore.Divider style={{marginTop: 20, marginBottom: 10}}/>
        {displayCallRecording && <>
          <div className={classes.sectionHeader}>
            Call Recording
          </div>
          <CallRecordingPlayer audioKey={message?.callRecordingAudioKey} />
        </>}
        {message.callRecordingTranscription &&
          <MuiCore.Tabs value={this.state.tabValue} onChange={(event, value) => this.setState({tabValue: value})} centered>  
              <MuiCore.Tab style={{fontFamily: 'Sofia-bold'}} label={<div><span style={{fontSize: '1rem'}}>Message</span><sup><InfoIcon style={{ fontSize: '0.9rem', verticalAlign: 'super', color: 'transparent' }} /></sup></div>} value={'Message'} />
              <MuiCore.Tab style={{fontFamily: 'Sofia-bold'}} label={<div><span style={{fontSize: '1rem'}}>Transcription</span><sup><MuiCore.Tooltip title="AI-generated content may be incorrect"><InfoIcon style={{ fontSize: '0.9rem', verticalAlign: 'super' }} /></MuiCore.Tooltip></sup></div>} value={'Transcription'} />
              <MuiCore.Tab style={{fontFamily: 'Sofia-bold'}} label={<div><span style={{fontSize: '1rem'}}>Sentiment</span><sup><MuiCore.Tooltip title="AI-generated content may be incorrect"><InfoIcon style={{ fontSize: '0.9rem', verticalAlign: 'super' }} /></MuiCore.Tooltip></sup></div>} value={'Sentiment'} />
          </MuiCore.Tabs>
        }

        {this.state.tabValue === 'Transcription' &&
          <MuiCore.Grid>
            <MuiCore.Grid style={{overflow: 'auto', maxHeight: 350}}>
            {!message.callRecordingTranscription || (!JSON.parse(message.callRecordingTranscription)?.utterances?.length > 0) ?
             <div style={{ display: 'flex', flexDirection: 'column', height: 350, justifyContent:'center', alignItems:'center'}}>
               <MuiCore.Typography style={{textAlign:'center', marginTop:'15px'}}>
                  No Transcript Found
                </MuiCore.Typography>
             </div>
                  :
                <div style={{marginTop: 10, display: 'flex', flexDirection: 'column', height: 350, marginBottom: 10}}>
                  {JSON.parse(message.callRecordingTranscription)?.utterances?.map((data, index) => (
                    <div key={index} style={{ display: 'flex', width: '100%', marginBottom: 6 }}>
                      {data.speaker === 'A' ? (
                        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start', width: '100%', flexDirection: 'column-reverse' }}>
                          <div style={{ display: 'flex', alignItems: 'center', marginRight: 5 }}>
                            <AccountCircle fontSize='small' style={{ marginBottom: 0, marginTop: 'auto', color: '#EF9CA1' }} />
                            <span style={{ fontSize: 12, marginLeft: 5, color: '#EF9CA1' }}>Agent</span>
                          </div>
                          <div className={classes.receivedMessageData}>
                            {data.text}
                          </div>
                        </div>
                      ) : (
                          <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end', width: '100%', flexDirection: 'column-reverse' }}>
                            <div style={{ display: 'flex', flexDirection: 'row-reverse', alignItems: 'center', marginLeft: 5 }}>
                              <AccountCircle fontSize='small' style={{ marginBottom: 0, marginTop: 'auto', color: '#7f2062' }} />
                              <span style={{ fontSize: 12, marginRight: 5, color: '#7f2062' }}>Caller</span>
                            </div>
                            <div className={classes.sentMessageData}>
                              {data.text}
                            </div>
                        </div>
                      )}
                    </div>
                  ))}
              </div>}
            </MuiCore.Grid>
          </MuiCore.Grid>
        }

        {this.state.tabValue === 'Sentiment' &&
           <MuiCore.Grid style={{maxHeight: 350}}>
             {!message.callRecordingTranscription || !JSON.parse(message?.callRecordingTranscription)?.sentiment_analysis_results ?   
              <div style={{ display: 'flex', flexDirection: 'column', height: 350, justifyContent:'center', alignItems:'center'}}>
                <MuiCore.Typography style={{textAlign:'center', marginTop:'15px'}}>No Sentiment Analysis</MuiCore.Typography> 
              </div>
              :
              <MuiCore.Grid container style={{marginTop: 15}}>
                <MuiCore.Grid item xs={6}>
                  <SentimentData sentimentData={JSON.parse(message?.callRecordingTranscription)?.sentiment_analysis_results} title={'Agent'} speaker='A'/>
                </MuiCore.Grid>
                <MuiCore.Grid item xs={6}>
                  <SentimentData sentimentData={JSON.parse(message?.callRecordingTranscription)?.sentiment_analysis_results} title={'Caller'} speaker='B'/>
                </MuiCore.Grid>
                <MuiCore.Grid item xs={6}>
                  <SentimentData sentimentData={JSON.parse(message?.callRecordingTranscription)?.sentiment_analysis_results} title={'Overall'}/>
                </MuiCore.Grid>
                <MuiCore.Grid item xs={6}>
                  <h4 style={{fontFamily:'Sofia', marginTop: -1}}>Detected Negative Phrases</h4>
                  <div style={{maxHeight: 130, overflow: 'auto', marginTop: -20}}>
                    {JSON.parse(message?.callRecordingTranscription)?.sentiment_analysis_results?.filter(result => result.sentiment === 'NEGATIVE').map((item, i) => (
                      <p style={{fontFamily:'Sofia'}}>{`${i+1}. ${item.text}`}</p>
                    ))}
                  </div>
                </MuiCore.Grid>
            </MuiCore.Grid>}
          </MuiCore.Grid>
        }

        {this.state.tabValue === 'Message' && <MuiCore.Grid style={{overflow: 'auto', height: 350, maxHeight: 350}}>
          <div className={classes.sectionHeader}>
            Call Details
          </div>

          <MuiCore.Grid>        
            
            <MuiCore.Grid item>
              <div className={classes.sectionHeader} style={{marginTop: 20}}>
                Caller Name: <span className={classes.fieldData}>{message.messageType === 'IC' ? (message.combinedDisplayName ? message.combinedDisplayName : '') : message.caller || 'VIP Contact'}</span>
              </div>
            </MuiCore.Grid>
            
            <MuiCore.Grid item>
              <div className={classes.sectionHeader}>
                Number:  <LinkedText value={Formatters.formatPhoneNumber(message.ani)}
                                  onClick={this.props.openContactLink} />
              </div>
            </MuiCore.Grid>

            <MuiCore.Grid item>
              <div className={classes.sectionHeader}>
                Called For: <span className={classes.fieldData}>{user.userAccountRoles.filter(account => account.accountId === message.accountId)[0]?.accountName}</span>
              </div>
            </MuiCore.Grid>

            <MuiCore.Grid item>
              <div className={classes.sectionHeader}>
                Caller ID Name: <span className={classes.fieldData}>{message.combinedDisplayName ? message.combinedDisplayName : ''}</span>
              </div>
            </MuiCore.Grid>

            <MuiCore.Grid item>
              <div className={classes.sectionHeader}>
                Caller ID Number: <LinkedText value={Formatters.formatPhoneNumber(message.ani)}
                                  onClick={this.props.openContactLink} />
              </div>
            </MuiCore.Grid>

            <div className={classes.sectionHeader} style={{marginTop: 20}}>
              Gathered Name: 
            </div>

            <div className={classes.sectionHeader}>
              Gathered Number: 
            </div>
            <div className={classes.sectionHeader}>
              All Other Fields:
            </div>

            <div className={classes.sectionHeader} style={{marginTop: 20}}>
                Company:  <span className={classes.fieldData}>{user.userAccountRoles.filter(account => account.accountId === message.accountId)[0]?.accountName}</span>
              </div>

            
            
            <MuiCore.Grid item>
                <div className={classes.sectionHeader} style={{marginTop: 20}}>
                  Duration
                </div>
                <div style={{fontFamily: 'Sofia'}}>
                    Receptionist Time: {message.billableAgentMinutes !== undefined ? this.formatTime(message.billableAgentMinutes * 60) : '00:00:00'}
                </div>
                <div style={{fontFamily: 'Sofia'}}>
                  Call Length: {message.callLengthInSeconds !== undefined ? this.formatTime(message.callLengthInSeconds, true) : '00:00:00'}
                </div>
            </MuiCore.Grid>
            
            <MuiCore.Hidden xlDown={!message.contactDescription}>
                <div className={classes.sectionHeader} style={{marginTop: 20}}>
                  Outcome
                </div>
                <div style={{fontFamily: 'Sofia'}}>
                    {message.contactDescription}
                </div>
            </MuiCore.Hidden>

            <MuiCore.Hidden xlDown={!message.callTagName}>
                <div style={{marginTop: 20}}>
                  <span className={classes.sectionHeader}>Tag: </span>
                  <span style={{fontFamily: 'Sofia'}}>
                    {message.callTagName}
                  </span>
                </div>
            </MuiCore.Hidden>
            
            {message.taskAgent && <MuiCore.Grid item style={{display: 'flex', justifyContent: 'center', marginTop: 10}}>
              <MuiCore.Grid item style={{textAlign: 'center', margin: 10}}>
                <svg xmlns="http://www.w3.org/2000/svg" width="38" height="42.067" viewBox="0 0 38 42.067">
                  <g id="receptionist" transform="translate(0)">
                    <path id="Path_47" data-name="Path 47" d="M37.337,6.6A6.106,6.106,0,0,1,38.9,10.3a4.938,4.938,0,0,1-1.006,2.978A5.5,5.5,0,0,1,35.324,15.1a5.881,5.881,0,0,1-3.2.329,4.678,4.678,0,0,1-1.006-.123,8.085,8.085,0,0,1-1.006-.288,7.912,7.912,0,0,1-.411,1.5q-.288.76-.575,1.5a9.31,9.31,0,0,1-1.15,1.992q-.7.924-1.438,1.828a5.04,5.04,0,0,1-.842.883,9.207,9.207,0,0,1-.965.719.616.616,0,0,0,.1.329.849.849,0,0,1,.1.452l.205-.164L26.9,30.468l1.6.37.616.205v1.808l.411,1.6v.205l1.191,3.41.616,4.19H10.1l1.4-4.19a13.33,13.33,0,0,0,.9-1.006,13.331,13.331,0,0,1,.9-1.006A21.372,21.372,0,0,1,14.928,34.6q.883-.719,1.787-1.335l2.013-1.6.781-.822.205-.781h.205l-.411-3.2.411.411-.411-2.013a4.539,4.539,0,0,1-1.006.472q-.555.185-1.006.308a4.354,4.354,0,0,1-2.465.493,4.877,4.877,0,0,1-2.342-.863,7.983,7.983,0,0,1-3.8-3.821,14.586,14.586,0,0,1-1.417-5.628A8.757,8.757,0,0,1,6.4,13.707a10.969,10.969,0,0,1-.329-2.67q0-.452.041-1.006A5.328,5.328,0,0,1,6.28,9.024q0-.164.021-.431A1.638,1.638,0,0,1,6.485,8,10.05,10.05,0,0,1,7.923,4.834a10.762,10.762,0,0,1,2.321-2.465,10.448,10.448,0,0,1,3.019-1.6A10.37,10.37,0,0,1,16.715.191q.452,0,.9.041a5.229,5.229,0,0,1,.9.164A1.713,1.713,0,0,0,19.2.6a2.08,2.08,0,0,1,.719.205A13.545,13.545,0,0,1,25.2,2.841a12.6,12.6,0,0,1,3.923,3.964q.288-.288.6-.555a3.8,3.8,0,0,1,.6-.431,5.088,5.088,0,0,1,3.677-.945A5.287,5.287,0,0,1,37.337,6.6ZM2.5,27.839a20.786,20.786,0,0,0,4.313-.452,20.177,20.177,0,0,0,4.149-1.274,20.937,20.937,0,0,0,3.821-2.136,19.959,19.959,0,0,0,3.328-2.958l.411.822-.9,1.027a12.783,12.783,0,0,1-2.794,2.362,24.437,24.437,0,0,1-5.012,2.444A24.931,24.931,0,0,1,2.3,29.03Zm2.794.205a2.133,2.133,0,0,1-.657,1.561,2.133,2.133,0,0,1-1.561.657,2.066,2.066,0,0,1-1.541-.657,2.232,2.232,0,0,1,0-3.122,2.066,2.066,0,0,1,1.541-.657,2.133,2.133,0,0,1,1.561.657A2.133,2.133,0,0,1,5.294,28.044Z" transform="translate(-0.898 -0.191)" fill="#414f78"/>
                  </g>
                </svg>
                <MuiCore.Typography style={{fontFamily: 'Sofia-bold', color: '#09122B', fontSize: 12}}>
                  {message.taskAgent}
                </MuiCore.Typography>
              </MuiCore.Grid>
            </MuiCore.Grid> }
          </MuiCore.Grid>
        </MuiCore.Grid>}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return ({
    user : coreSelectors.getUser(state),
    message : serviceSelectors.getMessage(state),
  });
};

const mapDispatchToProps = {
  openContactLink : serviceActions.openContactLink,
  toggleFollowup: serviceActions.toggleFollowup,
  openAssist : serviceActions.openAssist,
  archiveMessage : serviceActions.archiveMessage,
  unarchiveMessage : serviceActions.unarchiveMessage,
  markMessageRead : serviceActions.markMessageRead,
  unmarkMessageRead : serviceActions.unmarkMessageRead,
  setActivityDetailOpen : serviceActions.setActivityDetailOpen,
  newContact : serviceActions.newContact,
};

export default connect(mapStateToProps,
                       mapDispatchToProps)(withStyles(styles)(InboundCallFormat));

